//
//
//
//
//
//
//
//
//
//
//

export default {
	props: {
		mainLabel: {
			type: String
		},
		leftLabel: {
			type: String,
			required: true
		},
		rightLabel: {
			type: String,
			required: true
		},
		leftValue: {
			type: String,
			required: true
		},
		rightValue: {
			type: String,
			required: true
		},
		leftActive: {
			type: Boolean,
			default: true
		},
		rightActive: {
			type: Boolean,
			default: false
		},
		value: {
			type: String
		}
	},
	data: function data() {
		return {
			selectedValue: this.value
		};
	},

	methods: {
		selectThis: function selectThis(value) {
			this.selectedValue = value;
			this.$emit('input', this.selectedValue);
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/person/residents/new-resident-details/reusable/NewButtonToggle.vue
// module id = PpQQ
// module chunks = 0 1